export default __webpack_public_path__ + "df5ddf2b5143d47cb321d22f82a8b628.png";